import { render, staticRenderFns } from "./SnykAnalyzer.vue?vue&type=template&id=1163f4fc&"
import script from "./SnykAnalyzer.vue?vue&type=script&lang=js&"
export * from "./SnykAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1163f4fc')) {
      api.createRecord('1163f4fc', component.options)
    } else {
      api.reload('1163f4fc', component.options)
    }
    module.hot.accept("./SnykAnalyzer.vue?vue&type=template&id=1163f4fc&", function () {
      api.rerender('1163f4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/analyzers/SnykAnalyzer.vue"
export default component.exports